import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=5322c5ba&"
import script from "./AccountDetail.vue?vue&type=script&lang=js&"
export * from "./AccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./styles/CrmAccountDetail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5322c5ba')) {
      api.createRecord('5322c5ba', component.options)
    } else {
      api.reload('5322c5ba', component.options)
    }
    module.hot.accept("./AccountDetail.vue?vue&type=template&id=5322c5ba&", function () {
      api.rerender('5322c5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/AccountDetail.vue"
export default component.exports